/* SimScrubs - simscrubs.js */

document.addEventListener('DOMContentLoaded', function () {

  // -- NAV TOGGLE --
  const toggle = document.getElementById('nav-toggle');
  const mobile = document.getElementById('nav-mobile');

  if (toggle && mobile) {
    toggle.addEventListener('click', function () {
      const open = mobile.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', open);
      mobile.setAttribute('aria-hidden', !open);
    });
  }

  // -- STICKY NAV SHADOW --
  const nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 10
        ? '0 2px 20px rgba(0,0,0,0.08)'
        : 'none';
    }, { passive: true });
  }

  // -- ACTIVE NAV LINK --
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // -- FAQ ACCORDION --
  window.toggleFaq = function (btn) {
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    // Close all
    document.querySelectorAll('.faq-item.open').forEach(function (el) {
      el.classList.remove('open');
      var trigger = el.querySelector('.faq-q');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    // Open clicked if was closed
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  // -- FADE-UP ON SCROLL --
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(
    '.how-card, .plan-card, .dest-card, .testimonial-card, .blog-card, ' +
    '.value-card, .agency-card, .referral-step'
  ).forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  // -- CONTACT FORM --
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = contactForm.querySelector('[type="submit"]');
      btn.textContent = 'Sending...';
      btn.disabled = true;
      // Shopify form submission handled by contact template
      setTimeout(function () {
        btn.textContent = 'Message sent';
      }, 1000);
    });
  }

  // -- PLAN CARD HOVER (subtle teal glow) --
  document.querySelectorAll('.plan-card:not(.featured)').forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      this.style.borderColor = 'var(--border-dark)';
    });
    card.addEventListener('mouseleave', function () {
      this.style.borderColor = '';
    });
  });

  // -- CART COUNT --
  var cartCount = document.getElementById('nav-cart-count');
  if (cartCount) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count > 0) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = 'flex';
        }
      })
      .catch(function() {});
  }

});
